/**
 * Formats a number as a price with currency symbol
 * @param price - The price to format
 * @param currency - The currency symbol to use (default: '€')
 * @returns Formatted price string
 */
export const formatPrice = (price: number, currency: string = '€'): string => {
  return `${currency}${price.toFixed(2)}`;
};